import ApiConnection from './connection';

const getAll = async (token, dateStart, dateEnd, patient) => ApiConnection.get(`arquives/${dateStart}/${dateEnd}`, { headers: { Authorization: `Bearer ${token}` }})
.then(response => {
  return {output:response.data, status: response.status};
}).catch((e) => {
  return {status: e.response.status}
});

const download = async (token, month, year, reports) => {
  try {
    const response = await ApiConnection.post(
      `arquives/download/${month}/${year}`,
      reports, // Envia os reports no corpo da requisição
      {
        headers: { Authorization: `Bearer ${token}` },
        responseType: "blob", // 🔥 ESSENCIAL
      }
    );
    return { output: response.data, status: response.status };
  } catch (e) {
    return { status: e.response?.status };
  }
};


export default function arquive() {
  return {
    getAll,
    download
  }
}